export default __webpack_public_path__ + "static/special-list-25f47ed5901012f1f1bd0c72a8e36a0a.png";